import React from "react";
import ReactDOM from "react-dom/client";
/* Fallback load for CRA if CSS @import is skipped by the bundler */
import "@fontsource-variable/geist/wght.css";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
